export class Tag {
  constructor() {
    this.id = "";
    this.name = "";
    this.createdBy = "";
  }
}
